import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { ImageLightBoxActions } from '../constants/image_light_box/image_light_box_actions';

class ImageLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
            invalid: false,
            invalidMessage: '',
            obj: { },
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.IMAGE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case ImageLightBoxActions.SHOW:
                    state.obj = action.payload;
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                    }
                    this.__emitChange();

                    break;

                case ImageLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = {};
                        this.__emitChange();
                    }

                    break;

                case ImageLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const ImageLightBoxStore = new ImageLightBoxStoreClass(Dispatcher);
export { ImageLightBoxStore };
